export const datepicker = () => {

	calendars()
	increments()
}

const calendars = () => {

	jQuery(document).ready(function ($) {
		$('[name="from"], [name="to"]').datepicker({
			dateFormat: 'dd-mm-yy',
			showAnim: 'fadeIn',
			changeMonth: true,
			changeYear: true
		})
	})
}

const increments = () => {

	function changeValue(fieldId, delta) {
		const input = document.getElementById(fieldId);
		let value = parseInt(input.value) || 0;
		const min = parseInt(input.min) || 0;
		value += delta;
		if (value < min) value = min;
		input.value = value;
	}

	document.querySelectorAll('.increase').forEach(button => {
		button.addEventListener('click', function () {
			changeValue(this.dataset.target, 1);
		});
	});

	document.querySelectorAll('.decrease').forEach(button => {
		button.addEventListener('click', function () {
			changeValue(this.dataset.target, -1);
		});
	});
}

export default () => { }